import { Button, Card, Center, Stack } from "@mantine/core"
import { modals } from "@mantine/modals"
import { useTranslation } from "react-i18next"
import { AppTitle } from "./AppTitle"

export function Modal404() {
  const { t } = useTranslation()
  return (
    <Center h="100%" w="100%">
      <Card p="lg" radius="md" shadow="lg" w={600}>
        <Center>
          <Stack>
            <AppTitle>404 {t("Not Found")}</AppTitle>
            <Button variant="light" onClick={() => modals.closeAll()}>
              {t("Close")}
            </Button>
          </Stack>
        </Center>
      </Card>
    </Center>
  )
}
